// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_PRODUCTS = "Inzer\u00e1ty";
